import React from "react";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import PersonIcon from "@mui/icons-material/Person";
import { toast } from "react-toastify";
import httpClient from "../../components/helpers/httpClient";

function Field({ label, value }) {
  if (!value) return null;
  return (
    <div className="mobile-field">
      <div className="mobile-field__label">{label}</div>
      <div className="mobile-field__value">{value}</div>
    </div>
  );
}

export default function MobileSubmissionDrawer({ open, submission, onClose, onRefresh }) {
  if (!submission) return null;

  const handleApprove = async () => {
    try {
      await toast.promise(
        httpClient.post(import.meta.env.VITE_API_URL + `/api/new-contacts/${submission.id}/approve`),
        {
          pending: "Approving submission...",
          success: "Submission approved 👍",
          error: "Failed to approve submission 😢",
        }
      );
      onRefresh?.();
      onClose();
    } catch (error) {
      console.error("Error approving submission:", error);
    }
  };

  const handleDelete = async () => {
    if (!window.confirm("Are you sure you want to delete this submission?")) return;

    try {
      await toast.promise(
        httpClient.post(import.meta.env.VITE_API_URL + "/api/new-contacts/bulk-delete", {
          submission_ids: [submission.id],
          delete_contacts: false,
        }),
        {
          pending: "Deleting submission...",
          success: "Submission deleted 👍",
          error: "Failed to delete submission 😢",
        }
      );
      onRefresh?.();
      onClose();
    } catch (error) {
      console.error("Error deleting submission:", error);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleString("nl-BE");
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: "min(95vw, 450px)",
          backgroundColor: "var(--mobile-bg)",
        },
      }}
    >
      <div className="mobile-drawer__header">
        <div style={{ fontWeight: 700, fontSize: 18, flex: 1 }}>Submission Details</div>
        <div style={{ display: 'flex', gap: '4px' }}>
          <IconButton onClick={handleApprove} style={{ color: "var(--primary-color-light)" }} aria-label="Approve">
            <CheckCircleOutlineIcon />
          </IconButton>
          <IconButton onClick={handleDelete} style={{ color: "var(--red, #f44336)" }} aria-label="Delete">
            <DeleteOutlineIcon />
          </IconButton>
          <IconButton onClick={onClose} aria-label="Close">
            <CloseIcon />
          </IconButton>
        </div>
      </div>

      <div className="mobile-drawer__content">
        <div style={{ marginBottom: '20px', padding: '12px', background: 'white', borderRadius: '12px', border: '1px solid var(--mobile-border)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
            <PersonIcon style={{ color: 'var(--primary-color)' }} />
            <div style={{ fontWeight: 700, fontSize: '16px' }}>
              {submission.contact_first_name} {submission.contact_last_name}
            </div>
          </div>
          <Field label="Email" value={submission.contact_email} />
          <Field label="Submitted" value={formatDate(submission.submitted_at)} />
          <Field label="Source" value={submission.source_tag || submission.source} />
          <Field label="Form Type" value={submission.form_type} />
        </div>

        {submission.message && (
          <div style={{ marginBottom: '20px' }}>
            <div style={{ fontWeight: 700, marginBottom: '8px', fontSize: '14px', color: 'var(--primary-color)' }}>MESSAGE</div>
            <div style={{ padding: '12px', background: 'white', borderRadius: '12px', border: '1px solid var(--mobile-border)', whiteSpace: 'pre-wrap', fontSize: '14px' }}>
              {submission.message}
            </div>
          </div>
        )}

        {submission.form_data && Object.keys(submission.form_data).length > 0 && (
          <div>
            <div style={{ fontWeight: 700, marginBottom: '8px', fontSize: '14px', color: 'var(--primary-color)' }}>ADDITIONAL DATA</div>
            <div style={{ padding: '12px', background: 'white', borderRadius: '12px', border: '1px solid var(--mobile-border)' }}>
              {Object.entries(submission.form_data).map(([key, value]) => (
                <div key={key} style={{ marginBottom: '8px' }}>
                  <div style={{ fontSize: '12px', color: 'var(--secondairy-medium-gray)', textTransform: 'uppercase' }}>{key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}</div>
                  <div style={{ fontSize: '14px' }}>{String(value)}</div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </Drawer>
  );
}

